import React from "react";

export enum SettingType {
    CAPTURING = "CAPTURING",
    DETECTION = "DETECTION",
    TRACKING = "TRACKING",
    FACE_QUALITY = "FACE_QUALITY",
    VERIFICATION = "VERIFICATION",
    LIVENESS = "LIVENESS",
    ATTRIBUTES = "ATTRIBUTES",
    ICAO = "ICAO",
    MANAGEMENT = "MANAGEMENT",
    DEVELOPER = "DEVELOPER",
    RESET = "RESET",
    ABOUT = "ABOUT",
    ACCOUNTS = "ACCOUNTS",
    ADJUDICATION = "ADJUDICATION"
}

export enum AdjudicationsTabType {
    ONCOMING = "ONCOMING",
    PENDING = "PENDING",
    SOLVED = "SOLVED",
    STATISTICS = "STATISTICS",
}

export enum StatisticsType {
    MMID = 'MMID',
    SYSTEM = 'SYSTEM'
}

export enum LicensingType {
    USAGE = "USAGE",
    CLOUD = "CLOUD",
    DONGLES = "DONGLES",
    INTERNET_LICENSING = "INTERNET_LICENSING"
}

export interface LicenseTabs {
    usage?: boolean,
    cloud?: boolean,
    dongles?: boolean,
    internetLicensing?: boolean
}

export interface NavigationState {
    page: React.FC<any> | null,
    selected: boolean,
    isDrawerOpen: boolean,
    isMobile: boolean,
    settingType: SettingType,
    statisticsType: StatisticsType,
    licensingType: LicensingType,
    licensingTabs: LicenseTabs
    optionsActive: boolean,
    isLoading: boolean,
    developerOptions: boolean,
    subjectUUID: string,
}

export const initNavigationState: NavigationState = {
    page: null,
    selected: false,
    isDrawerOpen: false,
    isMobile: false,
    settingType: SettingType.CAPTURING,
    statisticsType: StatisticsType.MMID,
    licensingType: LicensingType.USAGE,
    licensingTabs: {usage: undefined, cloud: undefined, dongles: undefined, internetLicensing: undefined},
    optionsActive: false,
    isLoading: false,
    developerOptions: false,
    subjectUUID: "",
}